var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFb2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6681 8.75466C17.6681 3.92209 13.7558 0 8.93529 0C4.1148 0 0.202515 3.92209 0.202515 8.75466C0.202515 12.9919 3.20659 16.5201 7.18874 17.3342V11.3811H5.44218V8.75466H7.18874V6.566C7.18874 4.87635 8.55978 3.50187 10.2452 3.50187H12.4284V6.12826H10.6818C10.2015 6.12826 9.80857 6.52222 9.80857 7.00373V8.75466H12.4284V11.3811H9.80857V17.4656C14.2186 17.0278 17.6681 13.2983 17.6681 8.75466Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb2);
export default __webpack_public_path__ + "static/media/fb-2.aa4fea2dc0c4a5dc4f11d6381e4cd6a8.svg";
export { ForwardRef as ReactComponent };